module.exports = __webpack_public_path__ + "img/VA2.481504ef.jpg";